import { render } from "./OwlDataGrid.vue?vue&type=template&id=1e2b9262"
import script from "./OwlDataGrid.vue?vue&type=script&lang=js"
export * from "./OwlDataGrid.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__